// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorPickerContainer .react-colorful .react-colorful__saturation {
  width: 236px;
  height: 164px;
  border-radius: 6px;
  margin-bottom: 16px;

}

.colorPickerContainer .react-colorful .react-colorful__hue {
  width: 220px;
  height: 8px;
  border-radius: 6px;
  margin-left: 8px;
}

.colorPickerContainer .react-colorful {
  height: auto;
}

.colorPickerContainer .react-colorful .react-colorful__hue-pointer {
  width: 16px;
  height: 16px;
  background-color: var(--content-primary-primary-inverted);
}

.colorPickerContainer .react-colorful .react-colorful__hue-pointer .react-colorful__pointer-fill {
  background-color: var(--content-primary-primary-inverted) !important;
}

.colorPickerContainer .react-colorful .react-colorful__saturation .react-colorful__saturation-pointer {
    width: 16px;
    height: 16px;
    border: 2px solid var(--content-primary-primary-inverted);
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/ColorPicker/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,oEAAoE;AACtE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAyD;AAC7D","sourcesContent":[".colorPickerContainer .react-colorful .react-colorful__saturation {\n  width: 236px;\n  height: 164px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n\n}\n\n.colorPickerContainer .react-colorful .react-colorful__hue {\n  width: 220px;\n  height: 8px;\n  border-radius: 6px;\n  margin-left: 8px;\n}\n\n.colorPickerContainer .react-colorful {\n  height: auto;\n}\n\n.colorPickerContainer .react-colorful .react-colorful__hue-pointer {\n  width: 16px;\n  height: 16px;\n  background-color: var(--content-primary-primary-inverted);\n}\n\n.colorPickerContainer .react-colorful .react-colorful__hue-pointer .react-colorful__pointer-fill {\n  background-color: var(--content-primary-primary-inverted) !important;\n}\n\n.colorPickerContainer .react-colorful .react-colorful__saturation .react-colorful__saturation-pointer {\n    width: 16px;\n    height: 16px;\n    border: 2px solid var(--content-primary-primary-inverted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
